import styles from './ContactForm.module.scss';
import { BloodTestForm, ECGForm, ImageScanForm } from './ServicesForm';

const ClinicSelectForm = ({ formData, handleChange, handleBooleanToggle, setFormData }: any) => {
	return (
		<>
			<h2 className={styles['section-title']}>Test Specifics</h2>
			<p>
				The following section must be completed in full. You will be informed as to which locations
				are appropriate, and the (rough) cost of these.
			</p>
			<label htmlFor="referringClinician">Please select a clinic</label>
			<select
				id="referringClinician"
				name="referringClinician"
				value={formData.referringClinician}
				onChange={handleChange}
				required
				className={styles['form-select']}
			>
				<option value="" disabled>
					Select a clinic
				</option>
				<option value="Nord Clinic">Nord Clinic</option>
				<option value="Diers Fertility Clinic">Diers Fertility Clinic</option>
				<option value="Centre For Men's Health">Centre For Men's Health</option>
				<option value="Other">Other</option>
			</select>
			{formData.referringClinician && (
				<>
					<h2 className={styles['subsection-title']}>Blood Tests</h2>
					<label>Do you need a blood test performed? *</label>
					<div className={styles['toggle-buttons']}>
						<button
							type="button"
							className={`${styles['toggle-button']} ${
								formData.bloodTestRequired === true ? styles['active'] : ''
							}`}
							onClick={() => handleBooleanToggle('bloodTestRequired', true)}
						>
							Yes
						</button>
						<button
							type="button"
							className={`${styles['toggle-button']} ${
								formData.bloodTestRequired === false ? styles['active'] : ''
							}`}
							onClick={() => handleBooleanToggle('bloodTestRequired', false)}
						>
							No
						</button>
					</div>
					{formData.bloodTestRequired &&
						(formData.referringClinician === 'Other' ? (
							<>
								<label htmlFor="otherBloodTestTypeRequired">
									Please specify the blood test you need. *
								</label>
								<input
									type="text"
									id="otherBloodTestTypeRequired"
									name="otherBloodTestTypeRequired"
									value={formData.otherBloodTestTypeRequired}
									onChange={handleChange}
									required
								/>
							</>
						) : (
							<BloodTestForm
								formData={formData}
								handleChange={handleChange}
								handleBooleanToggle={handleBooleanToggle}
							/>
						))}

					<h2 className={styles['subsection-title']}>Imaging Scans </h2>
					<label>Do you need imaging scans (e.g. X-Ray, MRI, CT, ultrasound)? *</label>
					<div className={styles['toggle-buttons']}>
						<button
							type="button"
							className={`${styles['toggle-button']} ${
								formData.imagingScanRequired === true ? styles['active'] : ''
							}`}
							onClick={() => handleBooleanToggle('imagingScanRequired', true)}
						>
							Yes
						</button>
						<button
							type="button"
							className={`${styles['toggle-button']} ${
								formData.imagingScanRequired === false ? styles['active'] : ''
							}`}
							onClick={() => handleBooleanToggle('imagingScanRequired', false)}
						>
							No
						</button>
					</div>
					{formData.imagingScanRequired && (
						<ImageScanForm
							formData={formData}
							handleChange={handleChange}
							setFormData={setFormData}
						/>
					)}
					<h2 className={styles['subsection-title']}>Resting ECG</h2>
					<label>Do you need a resting ECG performed? *</label>
					<div className={styles['toggle-buttons']}>
						<button
							type="button"
							className={`${styles['toggle-button']} ${
								formData.restingECGRequested === true ? styles['active'] : ''
							}`}
							onClick={() => handleBooleanToggle('restingECGRequested', true)}
						>
							Yes
						</button>
						<button
							type="button"
							className={`${styles['toggle-button']} ${
								formData.restingECGRequested === false ? styles['active'] : ''
							}`}
							onClick={() => handleBooleanToggle('restingECGRequested', false)}
						>
							No
						</button>
					</div>
					{formData.restingECGRequested && (
						<ECGForm
							formData={formData}
							handleChange={handleChange}
							handleBooleanToggle={handleBooleanToggle}
						/>
					)}
					<h2 className={styles['subsection-title']}>Other service</h2>
					<label>Do you need another service (such as a virtual consultation)? *</label>
					<div className={styles['toggle-buttons']}>
						<button
							type="button"
							className={`${styles['toggle-button']} ${
								formData.anotherServiceRequired === true ? styles['active'] : ''
							}`}
							onClick={() => handleBooleanToggle('anotherServiceRequired', true)}
						>
							Yes
						</button>
						<button
							type="button"
							className={`${styles['toggle-button']} ${
								formData.anotherServiceRequired === false ? styles['active'] : ''
							}`}
							onClick={() => handleBooleanToggle('anotherServiceRequired', false)}
						>
							No
						</button>
					</div>
					{formData.anotherServiceRequired && (
						<>
							<label htmlFor="requestedServiceDetails">
								Please provide details for this below.
							</label>
							<input
								type="text"
								id="requestedServiceDetails"
								name="requestedServiceDetails"
								value={formData.requestedServiceDetails}
								onChange={handleChange}
								required
							/>
						</>
					)}
				</>
			)}
		</>
	);
};

export default ClinicSelectForm;
